import { Box } from '@mantine/core';

import { RIGHT_SIDEBAR_PORTAL_TARGET_ID } from '../constants';

export function RightSidebarPortalTarget() {
	return <Box id={RIGHT_SIDEBAR_PORTAL_TARGET_ID} />;
}
